const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7,6.3c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l0,0C17.3,8.8,18,10.3,18,12c0,1.7-0.7,3.2-1.8,4.2 C15.2,17.3,13.7,18,12,18c-1.7,0-3.2-0.7-4.2-1.8C6.7,15.2,6,13.7,6,12c0-1,0.3-2,0.7-2.9l2.6,2.6c0.3,0.3,0.7,0.4,1.1,0.2 c0.4-0.2,0.6-0.5,0.6-0.9V5c0-0.3-0.1-0.5-0.3-0.7S10.3,4,10,4H4C3.6,4,3.2,4.2,3.1,4.6C2.9,5,3,5.4,3.3,5.7l2,2 C4.5,8.9,4,10.4,4,12c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C20,9.8,19.1,7.8,17.7,6.3z M9,8.6L6.4,6H9V8.6z"
});

const SvgRetry = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.1,
      fill: "none"
    },
    width: 24,
    height: 24
  }), _ref2));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRetry, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/retry.ba8d06c2.svg";
export { ForwardRef as ReactComponent };